/* eslint-disable */
export default {
  loading: '正在加载…',
} as const;

// @key: @#@"loading"@#@ @source: @#@"Loading ..."@#@
